import React from 'react'
import {Box, Text, HStack, useMultiStyleConfig} from '@chakra-ui/react'
import Countdown from 'react-countdown'
import PropTypes from 'prop-types'
import {FormattedMessage} from 'react-intl'
import {VerticalDividerIcon} from '../../icons'

const HeroBannerCountDownV2 = ({endingDate, variant = 'default', ...containerProps}) => {
    const styles = useMultiStyleConfig('HeroBannerCountdown', {variant})
    const end = new Date(endingDate).getTime()

    const renderer = ({days, hours, minutes, seconds}) => (
        <HStack {...styles.container} {...styles.v2Container} {...containerProps}>
            <Box {...styles.counterBox} {...styles.v2CounterBox}>
                <Box {...styles.time} {...styles.v2Time}>
                    <Text {...styles.timeNumber} {...styles.v2TimeNumber}>
                        {days}
                    </Text>
                </Box>
                <Text {...styles.text} {...styles.v2Text}>
                    <FormattedMessage id="hero_banner_countdown.label.days" defaultMessage="Days" />
                </Text>
            </Box>

            <VerticalDividerIcon {...styles.v2Divider} />

            <Box {...styles.counterBox} {...styles.v2CounterBox}>
                <Box {...styles.time} {...styles.v2Time}>
                    <Text {...styles.timeNumber} {...styles.v2TimeNumber}>
                        {hours}
                    </Text>
                </Box>
                <Text {...styles.text} {...styles.v2Text}>
                    <FormattedMessage
                        id="hero_banner_countdown.label.hours"
                        defaultMessage="Hours"
                    />
                </Text>
            </Box>

            <VerticalDividerIcon {...styles.v2Divider} />

            <Box {...styles.counterBox} {...styles.v2CounterBox}>
                <Box {...styles.time} {...styles.v2Time}>
                    <Text {...styles.timeNumber} {...styles.v2TimeNumber}>
                        {minutes}
                    </Text>
                </Box>
                <Text {...styles.text} {...styles.v2Text}>
                    <FormattedMessage
                        id="hero_banner_countdown.label.minutes"
                        defaultMessage="Minutes"
                    />
                </Text>
            </Box>

            <VerticalDividerIcon {...styles.v2Divider} />

            <Box {...styles.counterBox} {...styles.v2CounterBox}>
                <Box {...styles.time} {...styles.v2Time}>
                    <Text {...styles.timeNumber} {...styles.v2TimeNumber}>
                        {seconds}
                    </Text>
                </Box>
                <Text {...styles.text} {...styles.v2Text}>
                    <FormattedMessage
                        id="hero_banner_countdown.label.seconds"
                        defaultMessage="Seconds"
                    />
                </Text>
            </Box>
        </HStack>
    )

    return <Countdown key={end} date={end} renderer={renderer} />
}

HeroBannerCountDownV2.propTypes = {
    endingDate: PropTypes.string,
    variant: PropTypes.string,
}

export default HeroBannerCountDownV2
